// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import $ from 'jquery'
import './config/project'
import './config/rem'
import './config/wx'
import 'swiper/dist/css/swiper.css';
import '../static/css/cemetery.css';
import '../static/css/my.css';

import VueTouch from 'vue-touch'
Vue.use(VueTouch, { name: 'v-touch' })

// 全局使用 调试
// import Vconsole from 'vconsole'
// let vConsole = new Vconsole();
// Vue.use(vConsole);

import {checkLog} from '../static/js/checkLog';//登录状态检测
import '../static/js/bdMap.js';//百度地图异步加载

Vue.config.productionTip = false;

import Cookies from 'js-cookie';
let t = Cookies.get('t');
if(t!=''&&t!=undefined&&t!=null){
    window.localStorage.setItem("token",t);
    console.log('token',t)
    token=t;
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
});
router.afterEach(function(to, from){
    checkLog();
    if(from.name==null&&to.name=="personSearch"){
      Global.searchFlag = true;
    }else{
      Global.searchFlag = false;
    }

    if(from.name==null&&to.name=="jurisdiction"){
      Global.jurisFlag = true;
    }else{
      Global.jurisFlag = false;
    }
    if(from.name=="homePage"&&to.name=="city"){
      Global.cityFlag = true;
    }else{
      Global.cityFlag = false;
    }

    if(from.name=='city'&&to.name=="archiveArea"){
      Global.backFlag = true;
    }else{
      Global.backFlag = false;
    }
    if(from.name=='archiveArea'&&to.name=="city"){
      Global.ProFlag = true;
    }else{
      Global.ProFlag = false;
    }
    if(from.name=='ProvinceHome'&&to.name=="archiveArea"){
      Global.TypeFlag = true;
    }else{
      Global.TypeFlag = false;
    }
    
});



// WEBPACK FOOTER //
// ./src/main.js